import React, { Component } from 'react';
import { Button, Form, Input, InputNumber, Row, Col, message, DatePicker, Icon, Upload} from 'antd';
import './css/style.css';
import logo from './img/logo.png';
import gql from 'graphql-tag'
import moment from 'moment'
import loadImage from 'blueimp-load-image'
import { withRouter } from 'react-router-dom'
import { graphql, compose, withApollo } from 'react-apollo'
import {HeaderContainer, BoxContainer, Channel} from '../pages/styled-components/index';
const FormItem = Form.Item;
const { TextArea } = Input;
const RangePicker = DatePicker.RangePicker;

const fileData = (url = '') => {
    const matches = url.match(/^data:(.+);base64,(.*)$/)
    if (!matches) {
      return null
    }
    const [, mimeType, base64data] = matches
    return {
      mimeType,
      base64data
    }
  }
const MAX_DIMENSION = 1800

class Editevent extends Component {
    state = {
        loading: false,
        visible: false,
        slugData: ''
      }
    
    handleslugChange = (e) => {
        // console.log(e.target.value)
        this.setState({
           slugData: e.target.value
        })
    }

    beforeUpload = (file, files) => {
        loadImage(file, canvas => {
          const imgUrl = canvas.toDataURL('image/jpeg', 0.95)
          file.thumbUrl = imgUrl
          this.props.form.setFieldsValue({
            file
          })
        }, {
          maxWidth: MAX_DIMENSION,
          maxHeight: MAX_DIMENSION,
          contain: true,
          orientation: true,
          canvas: true
        })
        return false
    }    

    render() {
        const { form } = this.props
        const { getFieldDecorator, getFieldValue } = this.props.form;

        const { event } = this.props.data
        if (this.props.data.loading || !event) {
            return <div>Loading...</div>
        }

        const { _id, slug, title, thumbnailUrl, startDate, endDate, donateTops, donationAllshirt, donationBykilo, maximumDistance, content, modalContent} = event
      
        const handleFromSubmit = (e) => {
            e.preventDefault()
            form.validateFields((err, values) => {
              if (err) {
                return console.error(err)
              }
      
            const { slug, title, file, dateRange, donateTops, donationBykilo, donationAllshirt, maximumDistance, content, modalContent } = values

            const [startDate, endDate] = dateRange
            this.props.updateEvent({
                variables: {
                    record: {
                        _id,
                        slug,
                        title,          
                        donateTops,              
                        donationBykilo,              
                        donationAllshirt,              
                        maximumDistance,              
                        content,             
                        startDate,              
                        endDate,           
                        modalContent       
                    },
                    file: (file && file.thumbUrl) ? fileData(values.file.thumbUrl) : null
                  },
                }).then(res => {
                    message.info(`Event "${title}" updated`)
                    setTimeout(function(){ window.location.href=`/event`}, 1000);
                    
                    // message.success('Event of success');
                    // window.location.href=`/editEvent/${_id}`
                })
            });
          }
        //   console.log(thumbUrl)
        // const fileDecorator = getFieldDecorator('file', {
        //     rules: [{ 
        //       required: true, 
        //       message: 'Please input your image!',
        //     }]
        // })
        const fileDecorator = getFieldDecorator('file')
        const file = getFieldValue('file')
        const fileProps = {
            name: 'file',
            accept:'.png, .jpeg, .jpg, .PNG, .JPEG, .JPG',
            action: '',
            showUploadList: false,
            fileList: file ? [file] : [],
            listType: 'picture',
            beforeUpload: this.beforeUpload,
        }
        const timeStart = moment(startDate, 'YYYY-MM-DD HH:mm:ss')
        const timeEnd = moment(endDate, 'YYYY-MM-DD HH:mm:ss')
        const dateRange = [timeStart, timeEnd]

        const rangeConfig = {
            rules: [{ type: 'array', required: true, message: 'Please select time!' }],
        };
        const slugConfig ={
            rules: [{ required: true, message: 'Please input the slug of Event!'}],
        };
        const titleConfig ={
            rules: [{ required: true, message: 'Please input the title of Event!'}],
        };
        
        const formItemLayout = {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 10 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 14 },
            },
        };
        // const dateRange = [event.startDate, event.endDate]
        return (
            <Form onSubmit={handleFromSubmit}>
                <Row>
                    <Col style={{marginTop:'100px'}} /> 
                    <Col className="header">
                        <HeaderContainer>
                            <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-start'}}>
                                <img src={logo} alt="logo" />
                                <a href="/event" className='backhome'>
                                  <strong>Event</strong>
                                </a>
                                <a href="/comprehendEvent" className='backhome'>
                                  <strong>Report</strong>
                                </a>
                            </div> 
                        </HeaderContainer>   
                    </Col>
                </Row>
                <BoxContainer>
                    <Channel>
                        <FormItem hasFeedback {...formItemLayout} label="Event title">
                            {getFieldDecorator('title' ,{
                                ...titleConfig,
                                initialValue : title
                            })(
                                <Input
                                  onChange={this.handleslugChange}
                                />
                            )}
                        </FormItem>
                        <FormItem hasFeedback {...formItemLayout} label="Slug">
                            {getFieldDecorator('slug', {
                                ...slugConfig,
                                initialValue: slug
                            })(
                                <Input
                                  onChange={this.handleslugChange}
                                />
                            )}
                        </FormItem>
                        <FormItem hasFeedback {...formItemLayout} label="วัน/เวลาเปิด-ปิดการส่งผล">
                            {getFieldDecorator('dateRange', {
                                ...rangeConfig,
                                initialValue: dateRange
                            })(
                                <RangePicker showTime format="YYYY-MM-DD HH:mm:ss" />
                            )}
                        </FormItem>

                        <FormItem hasFeedback {...formItemLayout} label="กราฟฟิกรูปภาพ Event">
                            {fileDecorator(<Upload {
                                ...fileProps
                            }>
                                {file ?
                                    <div style={{display:'flex', alignItems:'center'}}>
                                        <img style={{width:'150px',paddingRight:'10px'}} src={file.thumbUrl} alt=""/> 
                                        <Button style={{marginLeft:'10px'}}> แก้ไข </Button>
                                    </div>: 
                                    <div style={{display:'flex', alignItems:'center'}}>
                                        <img style={{width:'150px',paddingRight:'10px'}} src={thumbnailUrl} alt=""/> 
                                        <Button style={{marginLeft:'10px'}}> แก้ไข </Button>
                                    </div>
                                }
                            </Upload>)}
                        </FormItem> 



                        <FormItem 
                            hasFeedback
                            {...formItemLayout}
                            label="ยอดบริจาคเสื้อ 1 ตัว (บาท)"
                        >
                        {getFieldDecorator('donateTops', {
                            initialValue: donateTops
                        })(
                            <InputNumber style={{width:'50%'}}/>
                        )}
                        </FormItem>
                        <FormItem 
                            hasFeedback
                            {...formItemLayout}
                            label="ยอดบริจาคจากการขายเสื้อ (บาท)"
                        >
                        {getFieldDecorator('donationAllshirt', {
                            initialValue: donationAllshirt
                        })(
                            <InputNumber style={{width:'50%'}}/>
                        )}
                        </FormItem>
                        <FormItem 
                            hasFeedback
                            {...formItemLayout}
                            label="ยอดบริจาคแต่ละกิโลเมตร (บาท)"
                        >
                        {getFieldDecorator('donationBykilo', {
                            initialValue: donationBykilo
                        })(
                            <InputNumber style={{width:'50%'}}/>
                        )}
                        </FormItem>
                        <FormItem 
                            hasFeedback 
                            {...formItemLayout}
                            label="ยอดบริจาคไม่เกินต่อkm.(บาท)"
                        >
                        {getFieldDecorator('maximumDistance', {
                            initialValue: maximumDistance
                        })(
                            <InputNumber style={{width:'50%'}}/>
                        )}
                        </FormItem>
                        <FormItem 
                            hasFeedback 
                            {...formItemLayout} 
                            label="Content">
                            {getFieldDecorator('content', {
                                initialValue: content
                            })(
                                <TextArea autosize={{ minRows: 2, maxRows: 6 }} />
                            )}
                        </FormItem>
                        <FormItem 
                            hasFeedback 
                            {...formItemLayout} 
                            label="Content - Ecer">
                            {getFieldDecorator('modalContent', {
                                initialValue: modalContent
                            })(
                                <TextArea autosize={{ minRows: 2, maxRows: 6 }} />
                            )}
                        </FormItem>
                        <FormItem >
                            <Button type="primary" htmlType="submit" loading={this.state.loading} ><Icon type="save"/>seve</Button>
                            <Button className="btn-delete" style={{ marginLeft:'10px' }} >cancel</Button>
                        </FormItem> 
                    </Channel>
                </BoxContainer>
            </Form>
    );
  }
}
const queryEvent = gql`
  query queryevents($eventId: MongoID!){
    event (_id: $eventId) {
      _id
      slug
      title
      startDate              
      endDate
      thumbnailUrl
      donateTops                            
      donationBykilo              
      maximumDistance              
      donationAllshirt              
      targetedAmount          
      content             
      modalContent 
    }
  }
`

const updateEventMutation = gql`
mutation updateEvent($record: UpdateByIdEventInput!, $file: Base64FileInput){
    updateEvent(record: $record ,file: $file){
        record {
          _id
          slug
          title
          startDate              
          endDate
          donateTops                            
          donationBykilo              
          maximumDistance              
          donationAllshirt              
          targetedAmount          
          content             
          modalContent              
        }
    }
}`

export default 
    compose(
    withApollo,
    withRouter,
    Form.create() ,
        graphql(queryEvent, {
            options: props => ({
            variables: {
                eventId: props.match.params.eventId
            }
            })
        }),
        graphql(updateEventMutation,{
            name: 'updateEvent'
        },
    ),
    )(Editevent);

  


// WEBPACK FOOTER //
// ./src/components/pages/editEvent.js